import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgJumpingMan = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "Jump_icon",
	xmlns: "http://www.w3.org/2000/svg",
	width: 39,
	height: 39,
	viewBox: "0 0 39 39",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("rect", {
			id: "Rectangle_370",
			width: 38,
			height: 38,
			transform: "translate(0.5 0.5)",
			fill: "none",
			stroke: "rgba(4,5,5,0)",
			strokeWidth: 1
		}),
		/* @__PURE__ */ _jsxs("g", {
			id: "Groupe_2680",
			"data-name": "Groupe 2680",
			children: [
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2417",
					"data-name": "Trac\\xE9 2417",
					d: "M20.7,13.2a3.46,3.46,0,0,0,4.2-2.8c.1-3.2-.3-5.7.3-6.6A2.577,2.577,0,0,1,28.7,3c1.3.9,1.1,2.1,1.1,3.1v4.3A8.219,8.219,0,0,1,22.5,18c-.3,0-.1.8-.1,1v9.4a3.085,3.085,0,0,0,.1.9c1-1.7,1.8-4,2.6-4.7a2.836,2.836,0,0,1,4,.2A2.885,2.885,0,0,1,34,27.3a16.386,16.386,0,0,1-1.4,3,17.28,17.28,0,0,1-1.6,3,7.685,7.685,0,0,1-8.1,2.9,2.161,2.161,0,0,0-1.1.1,19.269,19.269,0,0,1-2.4.1c-1.3-.1-3.9-1.3-4.1-2.1a.735.735,0,0,1,.4-.8c.7-.3,1.2.5,1.8.7a5.966,5.966,0,0,0,2.6.7,8.039,8.039,0,0,1-3.3-7,.719.719,0,0,1,1.4.3,6.431,6.431,0,0,0,3.9,6.2A6.311,6.311,0,0,0,29,33.1a11.077,11.077,0,0,0,2.1-3.2c.5-.9.9-1.8,1.4-2.8a1.345,1.345,0,0,0-.6-1.8c-1.5-.8-2.1.7-2.6,1.7-.9,1.6-1.5,3.6-2.7,4.4a3.891,3.891,0,0,1-3.9.1A3.892,3.892,0,0,1,21,27.8V25.1c0-.2.1-.5-.2-.5-2.3,0-4.6-.1-6.8,0v4.3a.822.822,0,0,1-.4.6c-1,.4-1-.8-1-1.4v-10c0-.2.1-.3-.2-.3a8.041,8.041,0,0,1-6.8-5.3A11.667,11.667,0,0,1,5,7.9c.1-1.5-.3-3.2.4-4.2A2.459,2.459,0,0,1,9.9,5.1c.1,3.6-.4,5.8,1,7.1a3.785,3.785,0,0,0,3.2,1c0-.1,0-.1-.1-.2a4.723,4.723,0,0,1-1-3.8,4.578,4.578,0,0,1,6.7-3.6C22.3,7,22.7,11,20.7,13.2ZM17.4,23.4c1.2,0,2.4.1,3.5,0,.1-1,0-2.1,0-3.1.1-.8-.2-3.2.2-3.4a.778.778,0,0,1,.8-.2,6.708,6.708,0,0,0,6.3-5.3c.2-1,.1-2.1.2-3.1,0-1.2.1-2.3,0-3.5a1.065,1.065,0,0,0-1.7-.5c-.6.5-.3,1.3-.4,2,0,3.7.6,6.7-3.4,8.2-1.8.4-3.7.1-5.5.2-1.8-.1-4.2.2-5.6-.2A4.91,4.91,0,0,1,8.6,11a16.95,16.95,0,0,1-.1-2.3V5.6c0-.5.1-1-.4-1.3-1.3-.8-1.8.4-1.7,1.4V9a6.738,6.738,0,0,0,6.3,7.6c.4,0,.8,0,1,.3.3.3.1.7.2,1.1v5.3C15.1,23.4,16.3,23.4,17.4,23.4ZM14.3,9.8a3.156,3.156,0,1,0,6.3.1A3.16,3.16,0,1,0,14.3,9.8Zm10.3,21c1.9-.2,2.1-1.8,2.9-3a11.938,11.938,0,0,0,.8-1.6,1.441,1.441,0,0,0-1.1-.9c-1.1-.1-1.5.7-1.8,1.5a18.646,18.646,0,0,0-1,2C23.5,30.5,22.9,30.6,24.6,30.8Z",
					fill: "#b3b3b3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2418",
					"data-name": "Trac\\xE9 2418",
					d: "M7.1,35c-1.6,0-1.6-1.4,0-1.4,1.5,0,1.5,1.4,0,1.4Z",
					fill: "#b3b3b3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2419",
					"data-name": "Trac\\xE9 2419",
					d: "M5.4,31.9c0,1.6-1.4,1.6-1.4,0-.1-1.5,1.4-1.5,1.4,0Z",
					fill: "#b3b3b3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2420",
					"data-name": "Trac\\xE9 2420",
					d: "M2.3,33.6c1.6,0,1.6,1.4,0,1.4-1.6.1-1.6-1.4,0-1.4Z",
					fill: "#b3b3b3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2421",
					"data-name": "Trac\\xE9 2421",
					d: "M4,36.8c0-1.6,1.4-1.6,1.4,0,0,1.5-1.4,1.5-1.4,0Z",
					fill: "#b3b3b3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2422",
					"data-name": "Trac\\xE9 2422",
					d: "M13.3,31.9a.7.7,0,1,1,1.4,0C14.7,32.9,13.4,32.8,13.3,31.9Z",
					fill: "#b3b3b3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2423",
					"data-name": "Trac\\xE9 2423",
					d: "M36.7,5.4c-1.6,0-1.6-1.4,0-1.4,1.5,0,1.5,1.4,0,1.4Z",
					fill: "#b3b3b3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2424",
					"data-name": "Trac\\xE9 2424",
					d: "M35,2.3c0,1.6-1.4,1.6-1.4,0C33.6.8,35,.8,35,2.3Z",
					fill: "#b3b3b3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2425",
					"data-name": "Trac\\xE9 2425",
					d: "M31.9,4c1.6,0,1.6,1.4,0,1.4-1.5.1-1.5-1.4,0-1.4Z",
					fill: "#b3b3b3"
				}),
				/* @__PURE__ */ _jsx("path", {
					id: "Trac\\xE9_2426",
					"data-name": "Trac\\xE9 2426",
					d: "M33.6,7.1c0-1.6,1.4-1.6,1.4,0,0,1.5-1.4,1.5-1.4,0Z",
					fill: "#b3b3b3"
				})
			]
		})
	]
});
const ForwardRef = forwardRef(SvgJumpingMan);
export { ForwardRef as ReactComponent };
